import { CSSObjectWithLabel } from "react-select";
import React from "react";

const CustomStylesForSaleOperations = (
    error: boolean,
    touched: boolean,
    combined?: boolean,
    quantityWarnings?: boolean,
    isTopLabel?: boolean
) => {
    return {
        container: (provided: CSSObjectWithLabel) => ({
            ...provided,
            height: "49px",
        }),

        control: (provided: CSSObjectWithLabel, { isFocused }: { isFocused: boolean }) => {
            const defaultBorderColor = isFocused ? "#ACA1DF" : "#DEDEDE";
            const borderColor = touched && error ? "#DC3545" : quantityWarnings ? "#F8AC59" : defaultBorderColor;
            return {
                ...provided,
                borderColor: borderColor,
                padding: isTopLabel ? "12px 0px 2px" : "6px 0px",
                borderTopRightRadius: "4px",
                borderBottomRightRadius: "4px",
                borderTopLeftRadius: combined ? "0px" : "4px",
                borderBottomLeftRadius: combined ? "0px" : "4px",
                minHeight: "100%",
                boxShadow: isFocused
                    ? touched && error
                        ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
                        : quantityWarnings
                          ? "none"
                          : "0 0 0 0.2rem rgba(111, 66, 193, 0.25)"
                    : "none",
                "&:hover": {
                    borderColor: touched && error ? "#DC3545" : "#ACA1DF",
                },
            };
        },

        option: (provided: CSSObjectWithLabel, { isSelected }: { isSelected: boolean }) => ({
            ...provided,
            borderRadius: "4px",
            marginBottom: "8px",
            padding: "4px 32px 4px 12px",
            cursor: "pointer",
            position: "relative",
            backgroundColor: isSelected ? "#EEECF8" : "#FFFFFF",
            color: isSelected ? "#5842BE" : "#1F3354",
            "& .option-color": {
                color: isSelected ? "#5842BE" : "#9D9D9D",
            },
            "&:hover": {
                backgroundColor: "#f5f5f5",
                color: "#5842BE",
                "& .option-color": {
                    color: "#5842BE",
                },
            },
            "&::before": isSelected
                ? {
                      content: '"\\F633"',
                      fontFamily: "bootstrap-icons",
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#5842BE",
                      fontSize: "14px",
                  }
                : {},
        }),

        placeholder: (provided: CSSObjectWithLabel) => ({
            ...provided,
            fontSize: "14px",
            color: "#9D9D9D",
            margin: "0px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textAlign: "left",
            marginLeft: 0,
            paddingLeft: 0,
        }),

        input: (provided: CSSObjectWithLabel) => ({
            ...provided,
            fontSize: "14px",
            color: "#1F3354",
            textAlign: "left",
            marginLeft: 0,
            paddingLeft: 0,
            width: 0,
        }),

        dropdownIndicator: (provided: CSSObjectWithLabel, { selectProps }: any) => ({
            ...provided,
            transform: selectProps.menuIsOpen ? "rotate(180deg)" : null,
            transition: "transform 0.2s ease",
            color: "#1F3354",
            padding: isTopLabel ? "2px 12px" : "8px 12px",
            marginBottom: isTopLabel ? "8px" : 0,
        }),

        valueContainer: (provided: CSSObjectWithLabel) => ({
            ...provided,
            padding: "0 12px",
        }),

        menu: (provided: CSSObjectWithLabel) => ({
            ...provided,
            marginTop: "4px",
            zIndex: "600",
            textAlign: "left",
        }),

        menuPortal: (provided: CSSObjectWithLabel) => ({
            ...provided,
            zIndex: 1100,
        }),

        menuList: (provided: CSSObjectWithLabel) => ({
            ...provided,
            padding: "8px 12px",
        }),

        indicatorSeparator: () => ({
            display: "none",
        }),

        singleValue: (provided: CSSObjectWithLabel) => ({
            ...provided,
            fontSize: "14px",
            textAlign: "left",
            marginLeft: 0,
            paddingLeft: 0,
        }),
    };
};
export default CustomStylesForSaleOperations;
